export default {
  data() {
    return {
      total: 0,
      page: {
        pageNumber: 1,
        pageSize: 10
      }
    }
  },
  methods: {
    handleSizeChange(e) {
      this.page.pageSize = e
      this.getTableList()
    },
    handleCurrentChange(e) {
      this.page.pageNumber = e
      this.getTableList()
    }
  }
}
